// src/App.js

import React, { useEffect, useRef, useState } from 'react';

import NavBar from './Components/NavBar';
import ThemeToggle from './Components/ThemeToggle';
import RetroToggle from './Components/RetroToggle';

import './App.css';

import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from 'react-router-dom';

import GlobalBackground from './Views/GlobalBackground';

import HomePage from './Views/HomePage';

import Projects from './Views/Projects';
import Activity from './Views/Activity';
import Art from './Views/Art';
import CV from './Views/CV';
import { getSwipeDestination } from './swipeNavigation';
import './phone.css';

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const swipeStart = useRef(null);
  const [theme, setTheme] = useState(() => {
    const savedTheme = window.localStorage.getItem('theme');
    if (savedTheme === 'light' || savedTheme === 'dark') return savedTheme;
    return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
  });
  const [retroMode, setRetroMode] = useState(
    () => window.localStorage.getItem('ui-style') === 'retro'
  );

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    document.documentElement.style.colorScheme = theme;
    window.localStorage.setItem('theme', theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.dataset.ui = retroMode ? 'retro' : 'modern';
    window.localStorage.setItem('ui-style', retroMode ? 'retro' : 'modern');
  }, [retroMode]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  const handleTouchStart = (event) => {
    if (event.touches.length !== 1) {
      swipeStart.current = null;
      return;
    }

    const target = event.target;
    const isInteractive = target.closest(
      'a, button, input, textarea, select, [role="button"], [data-no-page-swipe]'
    );

    if (isInteractive) {
      swipeStart.current = null;
      return;
    }

    const touch = event.touches[0];
    swipeStart.current = { x: touch.clientX, y: touch.clientY };
  };

  const handleTouchEnd = (event) => {
    const start = swipeStart.current;
    swipeStart.current = null;

    if (!start || event.changedTouches.length !== 1) return;

    const touch = event.changedTouches[0];
    const deltaX = touch.clientX - start.x;
    const deltaY = touch.clientY - start.y;

    const destination = getSwipeDestination(location.pathname, deltaX, deltaY);
    if (destination) {
      navigate(destination, {
        state: { swipeDirection: deltaX < 0 ? 'forward' : 'backward' },
      });
    }
  };

  return (
    <div
      className="app-shell"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onTouchCancel={() => { swipeStart.current = null; }}
    >
    <GlobalBackground theme={theme} retroMode={retroMode} />

    <NavBar />
    <ThemeToggle
      theme={theme}
      onToggle={() => setTheme((current) => current === 'dark' ? 'light' : 'dark')}
    />
    <RetroToggle
      enabled={retroMode}
      onToggle={() => setRetroMode((current) => !current)}
    />

    <div
      key={location.pathname}
      className={`route-transition${
        location.state?.swipeDirection
          ? ` route-transition--${location.state.swipeDirection}`
          : ''
      }`}
    >
      <Routes location={location}>
        <Route path="/" element={<HomePage />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/art" element={<Art />} />
        <Route path="/cv" element={<CV />} />
      </Routes>
    </div>

    <footer className="site-footer">
      Designed &amp; developed by <span>Shashank.</span>
    </footer>
    </div>
  );
}

function App() {
return (
  <BrowserRouter>
    <AppContent />
  </BrowserRouter>
);
}

export default App;
